import { cn } from '@/lib/cn';
import { HelpTip } from '@/components/ui/HelpTip';

export interface PageHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  /** Clave de ayuda contextual (ver lib/help-texts.ts): pinta el botón "?". */
  helpKey?: string;
}

/** Encabezado consistente de página: título + "?" de ayuda + acción a la derecha. */
export function PageHeader({ title, description, action, className, helpKey }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-4', className)}>
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100">{title}</h1>
          {helpKey && <HelpTip helpKey={helpKey} />}
        </div>
        {description && <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{description}</p>}
      </div>
      {action && <div className="flex items-center gap-2">{action}</div>}
    </div>
  );
}
